import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { SITE } from "@/lib/api";

export default function SEO({ title, description, schema, image }) {
  const location = useLocation();
  const fullTitle = title ? `${title} | ${SITE.doctorName}` : SITE.doctorName;
  const currentUrl = `${SITE.domain}${location.pathname}`;
  const ogImage = image || `${SITE.domain}/logo_large.png`;
  const desc = description || SITE.tagline;

  useEffect(() => {
    // Set title
    document.title = fullTitle;

    // Helper to set meta tags
    const setMeta = (name, content, isProperty = false) => {
      if (!content) return;
      const attr = isProperty ? "property" : "name";
      let tag = document.querySelector(`meta[${attr}="${name}"]`);
      if (!tag) {
        tag = document.createElement("meta");
        tag.setAttribute(attr, name);
        document.head.appendChild(tag);
      }
      tag.setAttribute("content", content);
    };

    // Helper to set link tags
    const setLink = (rel, href) => {
      if (!href) return;
      let tag = document.querySelector(`link[rel="${rel}"]`);
      if (!tag) {
        tag = document.createElement("link");
        tag.setAttribute("rel", rel);
        document.head.appendChild(tag);
      }
      tag.setAttribute("href", href);
    };

    // Canonical URL
    setLink("canonical", currentUrl);

    // Description
    setMeta("description", desc);

    // OpenGraph
    setMeta("og:title", fullTitle, true);
    setMeta("og:description", desc, true);
    setMeta("og:url", currentUrl, true);
    setMeta("og:type", "website", true);
    setMeta("og:image", ogImage, true);
    setMeta("og:site_name", SITE.doctorName, true);
    setMeta("og:locale", "en_IN", true);

    // Twitter
    setMeta("twitter:card", "summary_large_image");
    setMeta("twitter:title", fullTitle);
    setMeta("twitter:description", desc);
    setMeta("twitter:image", ogImage);

    // Schema.org JSON-LD
    let script = document.querySelector('script[type="application/ld+json"]');
    if (schema) {
      if (!script) {
        script = document.createElement("script");
        script.setAttribute("type", "application/ld+json");
        document.head.appendChild(script);
      }
      script.textContent = JSON.stringify(schema);
    } else if (script) {
      script.remove();
    }

    return () => {
      if (script) script.remove();
    };
  }, [fullTitle, desc, currentUrl, schema, ogImage]);

  return null;
}
